export const blog = "/blog";
export const portfolio = "/portfolio";
